
webpack.register(
    'modules/live-video-pop-out/live-video-player/live-video-player',
    function() {
        return import('modules/live-video-pop-out/live-video-player/live-video-player');
    },
    true
);